import { ExternalLink } from "lucide-react";

/**
 * Embeds an Airtable form using its public embed URL.
 * Example src: https://airtable.com/embed/appXXXX/pagXXXX/form
 */
export default function AirtableFormEmbed({ src, title = "Airtable Form", height = 800, testId }) {
    return (
        <div className="w-full" data-testid={testId}>
            <iframe
                className="airtable-embed w-full rounded-2xl"
                src={src}
                title={title}
                width="100%"
                height={height}
                frameBorder="0"
                loading="lazy"
                style={{ background: "transparent", border: "1px solid #ccc" }}
            >
                Loading…
            </iframe>
            <a
                href={src}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 inline-flex items-center gap-1.5 text-sm text-ink-soft hover:text-ink transition-colors"
            >
                Open in new tab
                <ExternalLink size={14} />
            </a>
        </div>
    );
}
